// Copyright 2024 - MinIO, Inc. All rights reserved.

import React, { Fragment } from "react";
import { joinControlPlaneAsync } from "./setupThunks";
import { Box, Button, FormLayout, InputBox, ProgressBar } from "mds";
import { setCAHash, setEndpoint, setPsk, setSiteName } from "./setupSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

const SetupJoinForm = () => {
  const dispatch = useAppDispatch();

  const siteName = useAppSelector((state) => state.setup.siteName);
  const endpoint = useAppSelector((state) => state.setup.endpoint);
  const psk = useAppSelector((state) => state.setup.psk);
  const caHash = useAppSelector((state) => state.setup.caHash);
  const joinError = useAppSelector((state) => state.setup.joinError);
  const status = useAppSelector((state) => state.setup.status);

  return (
    <Fragment>
      {joinError && (
        <Box
          className={"error"}
          sx={{
            overflowWrap: "break-word",
            marginBottom: 16,
          }}
        >
          <b>{joinError.message}</b> <br />
          {joinError.detailedMessage}
        </Box>
      )}
      <FormLayout withBorders={false} containerPadding={false}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            dispatch(joinControlPlaneAsync());
          }}
        >
          <InputBox
            id={"site-name"}
            placeholder="Site Name (Optional)"
            value={siteName}
            onChange={(e) => dispatch(setSiteName(e.target.value))}
            disabled={status === "loading"}
          />
          <InputBox
            id={"endpoint"}
            placeholder="End-Point"
            value={endpoint}
            onChange={(e) => dispatch(setEndpoint(e.target.value))}
            disabled={status === "loading"}
          />
          <InputBox
            id={"psk"}
            placeholder="Pre-Shared Token"
            value={psk}
            onChange={(e) => dispatch(setPsk(e.target.value))}
            disabled={status === "loading"}
          />
          <InputBox
            id={"ca_hash"}
            placeholder="CA Hash"
            value={caHash}
            onChange={(e) => dispatch(setCAHash(e.target.value))}
            disabled={status === "loading"}
          />
          {status === "loading" && <ProgressBar />}
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              id={"register"}
              type={"button"}
              onClick={() => dispatch(joinControlPlaneAsync())}
              variant={"callAction"}
              disabled={status === "loading"}
            >
              {status === "loading" ? "Joining..." : "Join Control Plane"}
            </Button>
          </Box>
        </form>
      </FormLayout>
    </Fragment>
  );
};
export default SetupJoinForm;
